import BasketService from './BasketService'

export default class BasketItem {
  constructor (data) {
    if (!data || !data.id || !data.name || !data.service) throw new Error('Wrong BasketItem data')

    this.id = data.id
    this.nomenklatura = data.nomenklatura
    this.name = data.name
    this.service = new BasketService(data.service)
    this.price = data.price || 0
    this.newPrice = data.new_price || 0
    this.order = data.order || 0
    this.quantity = data.quantity || 1
    this.totalPrice = data.total_price || 0
    this.totalNewPrice = data.total_new_price || 0
  }
}
